import React from 'react';
import {airtable_config_get_label} from "../redux/actions";
import {useSelector} from "react-redux";

export const EmptyBox = () => {
    const locale = useSelector(state => state.app.locale)
    const configData = useSelector(state => state.app.configData)
    const error = useSelector(state => state.app.error)
    const message = configData !== null && error !== '' ? airtable_config_get_label(configData, error, locale) : null;
    return (
        <div className="empty-box">
            <div className="empty-box__error">
                {message}
            </div>
        </div>
    )
}